export default {
  name: 'EosIconsLoading'
};